module.exports = __webpack_public_path__ + "static/white-logo-ad2515e1c2c4af3125fe3f1a72d128dc.png";